import React, { useCallback, FC, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { WizardPage } from '../../../../general/components/wizard-page';
import { GET_STARTED } from '../../../../paths';
import { RootState } from '../../../../store';
import { resetAddressLookup } from '../../../address-verification/reducers/addressLookup';
import { BusinessInfoVerifyForm } from '../../components/business-info-verify-form';

const selector = ({ nextStep: { error } }: RootState) => ({
  error,
});

const BusinessInfoVerifyPage: FC = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { error } = useSelector(selector);
  const handleBack = useCallback(() => {
    navigate(GET_STARTED);
  }, [navigate]);

  useEffect(() => {
    dispatch(resetAddressLookup());
  }, [dispatch]);

  return (
    <WizardPage
      title="Tell us about your business"
      subtext="We need to verify your business details."
      error={error}
      onBack={handleBack}
    >
      <BusinessInfoVerifyForm />
    </WizardPage>
  );
};

export { BusinessInfoVerifyPage };
